exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-message[data-v-2525fa78]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#fff;padding:20px;border-radius:5px;box-shadow:0 2px 10px rgba(0,0,0,.1)}.fa-spinner[data-v-2525fa78]{margin-top:10px;font-size:24px;color:#3498db}", ""]);

// exports
